module.exports = __webpack_public_path__ + "img/logo.ff4c1bd2.png";